export default function SalePrice({ original, sale, enabled, suffix = "/ დღე", size = "md" }) {
  const big = size === "lg";
  if (!enabled || !sale) {
    return (
      <p className={`${big ? "text-2xl" : "text-2xl"} font-bold text-white`} data-testid="price-regular">
        {original} {suffix && <span className="text-sm font-normal text-gray-400">{suffix}</span>}
      </p>
    );
  }
  return (
    <div className="flex items-center gap-x-3 gap-y-1 flex-wrap" data-testid="price-sale">
      <p className={`${big ? "text-lg" : "text-base"} text-gray-500 line-through decoration-red-400/70 decoration-2`} data-testid="price-original">
        {original}
      </p>
      <p className={`${big ? "text-3xl" : "text-2xl"} font-bold text-[#E5C378]`} data-testid="price-sale-value">
        {sale} {suffix && <span className="text-sm font-normal text-gray-400">{suffix}</span>}
      </p>
      <span className="px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide bg-[#D4AF37] text-[#0A0B0E]" data-testid="price-sale-badge">
        ფასდაკლება
      </span>
    </div>
  );
}
